import React from 'react';
import Box from '@mui/material/Box';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import Typography from '@mui/material/Typography';

const NoAvailableCard = () => {
  return (
    <Box
      bgcolor="graphic.lighter"
      borderRadius="4px"
      fontFamily="Gothic A1"
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      mt={{ xs: 2, lg: 8 }}
      padding={3}
      textAlign="center"
      width="100%"
    >
      <BlockRoundedIcon
        sx={{
          color: 'text.secondary',
          height: 38,
          mb: 1,
          width: 38,
        }}
      />
      <Typography fontWeight={400} sx={{ color: 'text.secondary' }} variant="h6">
        Record could not be found.
      </Typography>
      <Typography fontWeight={300} sx={{ color: 'text.secondary' }} variant="body1">
        Verify the record ID you are looking for.
      </Typography>
    </Box>
  );
};

export default NoAvailableCard;
